
import { Directive, ElementRef, HostListener, Injector } from '@angular/core';
import IMask from 'imask';
import moment from 'moment';
import Swal from 'sweetalert2';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appTextMaskDate]',
  standalone: true
})
export class TextMaskDateDirective {
  private control: NgControl;
  private maskRef: ReturnType<typeof IMask>;

  constructor(private element: ElementRef, injector: Injector) {
    try {
      this.control = injector.get(NgControl);
    } catch (e) {
      console.error('NgControl not found', e);
    }

    // Create IMask date mask for dd/mm/yyyy
    this.maskRef = IMask(this.element.nativeElement, {
      mask: '00/00/0000', // Define the mask pattern for dd/mm/yyyy
      lazy: true, // Show placeholders always
      placeholderChar: ' ', // Use underscore as placeholder char
     autofix: true,
      overwrite: true,
    });
  }
  @HostListener('focus', ['$event'])
  setvalue() {
    this.maskRef.value = this.element.nativeElement.value
  }
  @HostListener('input', ['$event'])
  setvalue1() {
    const value = (event?.target as HTMLInputElement).value;
    if (!value || value?.trim() === '' || value.indexOf(' ') >= 0) {
      //  this.showInvalidDateAlert();

      this.control?.control?.reset();
      return;
    }
    const dateParts = value.split('/');

    //if (dateParts[0]?.trim()?.length != 2 || dateParts[1]?.trim()?.length != 2 || dateParts[2]?.trim()?.length != 4) {
    //  debugger
    //  this.control?.control?.setErrors({ Invalid: true });
    //  return;
    //}
    if (dateParts[0]?.trim()?.length != 2 && +dateParts[0]?.trim() > 3) {
      debugger
      this.maskRef.value = 0 + dateParts[0]?.trim()

    }
    else if (dateParts[0]?.trim()?.length == 2 && +dateParts[0]?.trim() > 31) {
      this.maskRef.value = '3'
    }
    
    else if (dateParts[0]?.trim()?.length == 2 && +dateParts[1]?.trim()[0] > 1) {
      debugger
      this.maskRef.value = dateParts[0] + '/' + '0' + dateParts[1]?.trim()[0]

    }
    else if (dateParts[0]?.trim()?.length == 2 && +dateParts[1]?.trim()[1] > 2 && +dateParts[1]?.trim()[0]!=0) {
      debugger
      this.maskRef.value = dateParts[0] + '/' +  dateParts[1]?.trim()[0]


    }
    //this.maskRef.value = this.element.nativeElement.value
  }

  @HostListener('blur', ['$event'])
  onBlur(event: FocusEvent) {
    
    const value = (event.target as HTMLInputElement).value;
    if (!value || value?.trim() === '' || value.indexOf(' ') >= 0) {
    //  this.showInvalidDateAlert();
      
      this.control?.control?.reset();
      return;
    }
    const dateParts = value.split('/');
    
    if (dateParts[0]?.trim()?.length != 2 || dateParts[1]?.trim()?.length != 2 || dateParts[2]?.trim()?.length != 4) {
      debugger
      this.control?.control?.setErrors({ Invalid: true });
      return;
    }
    if (dateParts[0]?.trim()?.length != 2 && +dateParts[0]?.trim() > 3) {
      debugger
      this.control?.control?.setValue(0 + dateParts[0]?.trim())

    }
    const isValidDate = moment(value, 'DD/MM/YYYY', true).isValid();

    const isBeforeThreshold = moment(value, 'DD/MM/YYYY').isBefore(moment('01/01/1753', 'DD/MM/YYYY'));
    if (!isValidDate) {
    } if (isBeforeThreshold) {
      this.showBeforeThresholdAlert();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
   
    event.preventDefault();
    const pastedInput = event.clipboardData?.getData('text/plain') || '';
    if (moment(pastedInput, 'DD/MM/YYYY', true).isValid()) {
      document.execCommand('insertText', false, pastedInput);
    }
  }
  private showBeforeThresholdAlert() {
    Swal.fire({
      html: `<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Invalid date!</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black" style="line-height:22px; padding-right: 30px !important;"> Date cannot be less than 01/01/1753</p></br>`,
      iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
      allowOutsideClick: false,
    }).then(() => {
      this.control?.control?.reset();
      setTimeout(() => {
        this.element.nativeElement.focus();
      }, 500);
    });
  }

}


